var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{staticClass:"ma-4 task-table",attrs:{"headers":_vm.headers,"items":_vm.requests,"hide-default-footer":"","disable-pagination":""},scopedSlots:_vm._u([{key:"item.id",fn:function(ref){
var item = ref.item;
return [_c('span',[_vm._v(_vm._s(item.id))])]}},{key:"item.chat_room_id",fn:function(ref){
var item = ref.item;
return [_c('v-btn',{staticClass:"ml-n4",attrs:{"to":{
        name: 'ExchangeRequests',
      },"color":"info","text":"","rounded":""}},[_vm._v("Ответить в чате")])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }